import React, { useEffect, useState } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button } from "reactstrap";
// import "./datatables.scss";
import '../Icons/IconFontawesome';

import Utils from '../Utility';
import { post, get, put } from "../../helpers/api_helper";
import Modal from './DeleteModal';
import DataTable from 'react-data-table-component';
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from 'react-toastify';

const ArchivedLeads = (props) => {
  const { user, setIsAddForm, setCurrentLead } = props;
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [moderator, setModerators] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [modalData, setModalData] = useState({ type: "Delete" });

  console.log('props on card on lead', props);

  useEffect(() => {
    if (user?.companyId) {
      getLeads();
    }
  }, [user]);

  useEffect(() => {
    setColumns([
      {
        name: 'Lead Name',
        selector: row => row.name,
      },
      {
        name: 'Client Email',
        selector: row => row.email,
      },
      {
        name: 'Client Mobile',
        selector: row => row.mobile,
      },
      {
        name: 'Description',
        selector: row => row.intro.length > 30 ? row.intro.substring(0, 30) + '...' : row.intro,
      },
      {
        name: 'Project',
        selector: row => row.project.length > 0 ? row.project[0]?.name : ' - ',
      },
      {
        name: 'Assigned Channel Partner',
        selector: row => row?.dealer.length > 0 ? row?.dealer[0].name : ''
      },
      {
        cell: (row) => <>

          <Button onClick={() => props?.history.push("/auto/lead/" + row?._id)}
            title={"View"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-eye" style={{ fontSize: 20 }}></span></Button>
          <Button onClick={() => handleArchivedLead(row)}
            title={"Unarchive"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-archive-arrow-up" style={{ fontSize: 20 }}></span></Button>
          {user?.role == 'Admin' || row?.addedBy == user?._id ?
            <Button onClick={() => handleUpdateLead(row)}
              title={"Edit"}
              style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
            : null
          }

        </>,
        name: 'Action',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ])
  }, [data]);

  const getLeads = async () => {
    get("/lead/auto/list?kind=archived&companyId=" + user?.companyId, { token: user?.token })
      .then(json => {
        console.log('response from get lead list', json);
        setData(json?.data);
      })
      .catch(error => {
        console.log('error while getting user list', error);
      })
  }

  const handleArchivedLead = (lead) => {
    console.log('updating lead', lead);
    setModalData({ type: "Unarchive", lead: lead });
    setIsModal(true);
  }

  const handleUpdateLead = (item) => {
    console.log('called handleUpdateLead', item);
    setCurrentLead(item); 
    setIsAddForm(true);
  }

  const onConfirm = () => {
    let body = {};
    if (modalData?.type == 'Unarchive') {
      body = {
        lead_id: modalData?.lead?._id,
        timeline: [...modalData?.lead?.timeline, { title: 'Unarchived', desc: `Lead unarchived by ${user?.name}` }],
        status: 'Open',
        token: user?.token,
        assignToM: null,
        assignToD: null
      };
    }
    put("/lead/update", body)
      .then(json => {
        console.log('response from delete user', json);
        if (json.statusCode == 200) {
          toast.success("Success");
          getLeads();
          setIsModal(false);
          setModalData({ type: "Delete" });
          props?.setReload(!props?.reload);
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  return (
    <React.Fragment>
      <div className="">
        <Modal
          show={isModal}
          onClick={() => onConfirm()}
          onCloseClick={() => setIsModal(false)}
          data={modalData}
        />
        <DataTable
          columns={columns}
          data={data}
          pagination
          customStyles={{
            headCells: {
              style: {
                color: 'black',
                fontWeight: 'bold',
                fontSize: 15,
                maxWidth: 80
              },
            },
            cells: {
              style: {
                maxWidth: 50
              }
            }
          }}
        />
      </div>
    </React.Fragment>
  )
}

export default ArchivedLeads;
